"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccineAdministered = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const Formatters_1 = require("../../common/Formatters");
const hui_1 = require("@mit/hui");
const PersonDetailsDrawer_1 = __importDefault(require("../common/PersonDetailsDrawer"));
const VaccineAdministeredComponent = ({ peopleStore, covidNav, isLoading }) => {
    var _a;
    const [showPerson, setShowPerson] = (0, react_1.useState)(false);
    const [person, setPerson] = (0, react_1.useState)();
    const viewPersonClose = () => {
        setPerson(undefined);
        setShowPerson(false);
    };
    const showPersonInfo = (item) => {
        setShowPerson(true);
        setPerson(item);
    };
    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    const getVaccineIcon = (status) => {
        if (status && status.toLowerCase() === "none")
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        if (status && status.toLowerCase() === "eligible")
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        if (status && status.toLowerCase() === "in_progress")
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "shield", color: "green" }) }));
        if (status && (status.toLowerCase() === "completed" || status.toLowerCase() === "full"))
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "solid", icon: "shield-check", color: "green" }) }));
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    const columns = [
        {
            id: "full_name",
            name: "Name",
            sortable: true,
            formatter: (item) => { return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "clickable", onClick: () => { showPersonInfo(item); } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: item.full_name }), "\u00A0", getVaccineIcon(item.vaccine_status)] }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Name"
            },
            filterable: true,
            filterOptions: {
                type: "textbox",
                onFilter: (item, value) => {
                    if (item.full_name.toLowerCase().indexOf(value.toLowerCase()) != -1)
                        return true;
                    return false;
                },
            }
        },
        {
            id: "mit_id",
            name: "MIT ID",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "MIT ID"
            },
            filterable: false
        },
        {
            id: "gender",
            name: "Gender",
            formatter: (item) => { return toTitleCase(item.gender); },
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Gender"
            },
            filterable: false
        },
        {
            id: "phone_number",
            name: "Phone",
            sortable: false,
            formatter: (item) => { return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: `tel:${item.phone_number}` }, { children: (0, Formatters_1.formatPhoneNumber)(item.phone_number) }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Phone"
            },
            filterable: false
        },
        {
            id: "email",
            name: "Email",
            sortable: false,
            formatter: (item) => { return ((0, jsx_runtime_1.jsx)("a", Object.assign({ className: "table-email", href: `mailto:${item.email}` }, { children: item.email }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Email"
            },
            filterable: false
        },
        {
            id: "date_of_birth",
            name: "Date of Birth",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Date of Birth"
            },
            filterable: false
        },
        {
            id: "vaccine_date",
            name: "Recieved on",
            sortable: true,
            formatter: (item) => { return item.shot_date; },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Flu Shot Date"
            }
        },
        {
            id: "body_region_name",
            name: "Body Region",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Body Region"
            },
            filterable: false
        },
        {
            id: "lot_number",
            name: "Lot Number",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Lot Number"
            },
            filterable: false
        },
        {
            id: "location_name",
            name: "Location",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Location"
            }
        },
        {
            id: "test_by_full_name",
            name: "Administered By",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Administered By"
            }
        },
    ];
    const data = (_a = peopleStore.vaccineList) === null || _a === void 0 ? void 0 : _a.map((person, index) => {
        return Object.assign(Object.assign({}, person), { gender: person.gender ? person.gender : '-', phone_number: person.phone_number ? (0, Formatters_1.formatPhoneNumber)(person.phone_number) : '-', email: person.email ? person.email : '-', date_of_birth: person.date_of_birth ? (0, Formatters_1.displayDate)(person.date_of_birth) : '-', flu_shot_date: person.flu_shot_date ? (0, Formatters_1.usDateTime)(person.flu_shot_date) : '-' });
    });
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data ? data : [], showExportButton: false, showFilterButton: true, isLoading: isLoading || covidNav.globalTableIsLoading, noDataText: "No results found", theme: "medical", sortStateOptions: {
                    enabled: true,
                    key: 'covid-medical-vaccine-administered'
                } }), (0, jsx_runtime_1.jsx)(PersonDetailsDrawer_1.default, { id: person === null || person === void 0 ? void 0 : person.mit_id, show: showPerson, onClose: viewPersonClose })] });
};
exports.VaccineAdministered = (0, mobx_react_1.inject)('peopleStore', 'covidNav')((0, mobx_react_1.observer)(VaccineAdministeredComponent));
